import React from 'react'
import cn from 'classnames'
import { Form, Checkbox } from 'util/ui'
import ValidatedField from 'shared/components/ui/ValidatedField'
import ParsedInput from 'shared/components/ui/ParsedInput'
import { propFunc } from 'util/functions'
import { slugify } from 'util/url'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import { validateAccountSubdomain } from 'util/validation'
import sharedStyles from '../../../sharedForm/styles.less'
import styles from '../styles.less'

const subdomainLabelOptions = { basic: true, content: '.groovehq.com' }

class SignupForm extends React.PureComponent {
  componentDidMount() {
    const { redirectToHomeIfAuthenticated } = this.props
    redirectToHomeIfAuthenticated()
  }

  manualSubdomain = false

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    onChange(name, value)
  }

  handleCheckboxChange = (name, _, { checked }) => {
    const { onChange, onValidate } = this.props
    onChange(name, checked)
    onValidate(name, checked)
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    onValidate(name, formFields[name])
  }

  handleCompanyBlur = () => {
    const { onChange, formFields, onValidate } = this.props
    if (!this.manualSubdomain && formFields.companyInput) {
      const subdomain = slugify(formFields.companyInput)
      validateAccountSubdomain(subdomain).then(response => {
        if (this.manualSubdomain) return
        const finalValue = response ? response.suggestion : subdomain
        onChange('subdomainInput', finalValue, null).then(() => {
          this.moveCursorToEndOfSubdomainInput()
          onValidate('subdomainInput', finalValue)
        })
      })
    }
  }

  moveCursorToEndOfSubdomainInput = () => {
    const input =
      this.subdomainRef &&
      this.subdomainRef.inputRef &&
      this.subdomainRef.inputRef.current
    if (input) {
      input.selectionStart = 0
      input.selectionEnd = 0
      setTimeout(() => {
        input.selectionStart = input.value.length
        input.selectionEnd = input.value.length
      }, 1)
    }
  }

  handleSubdomainChange = (_, { value }) => {
    const { onChange } = this.props
    this.manualSubdomain = true
    onChange('subdomainInput', value, null, { validate: !!value })
  }

  handleSubdomainBlur = () => {
    const { formFields } = this.props
    if (!formFields.subdomainInput) {
      this.manualSubdomain = false
    }
  }

  takeSubdomainRef = node => {
    disableLastPassInputRef(node)
    if (node) {
      this.subdomainRef = node
    }
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      submitForm,
      passwordStrength,
      canSave,
      saving,
      pendingValidationFields,
    } = this.props
    return (
      <Form size="large" className={sharedStyles.form}>
        <Form.Field>
          <ValidatedField
            placeholder="First & Last name"
            type="text"
            value={formFields.firstLastNameInput}
            errorMessage={formFieldsErrors.firstLastNameInput}
            onChange={propFunc(this.handleChange, 'firstLastNameInput')}
            onBlur={propFunc(this.handleBlur, 'firstLastNameInput')}
            fieldRefCallback={disableLastPassInputRef}
          />
        </Form.Field>
        <Form.Field>
          <ValidatedField
            placeholder="Email Address"
            type="email"
            value={formFields.emailInput}
            errorMessage={formFieldsErrors.emailInput}
            onChange={propFunc(this.handleChange, 'emailInput')}
            onBlur={propFunc(this.handleBlur, 'emailInput')}
            fieldRefCallback={disableLastPassInputRef}
          />
        </Form.Field>
        <Form.Field>
          <ValidatedField
            className={cn({
              [styles.success]: passwordStrength === 2,
              [styles.warning]: passwordStrength === 1,
            })}
            placeholder="Password"
            type="password"
            value={formFields.passwordInput}
            errorMessage={formFieldsErrors.passwordInput}
            onChange={propFunc(this.handleChange, 'passwordInput')}
            onBlur={propFunc(this.handleBlur, 'passwordInput')}
            fieldRefCallback={disableLastPassInputRef}
          />
        </Form.Field>
        <Form.Field>
          <ValidatedField
            placeholder="Company"
            type="text"
            value={formFields.companyInput}
            errorMessage={formFieldsErrors.companyInput}
            onChange={propFunc(this.handleChange, 'companyInput')}
            onBlur={this.handleCompanyBlur}
            fieldRefCallback={disableLastPassInputRef}
          />
        </Form.Field>
        <Form.Field>
          <ValidatedField
            className={styles.domainInput}
            loading={pendingValidationFields.subdomainInput}
            placeholder="Subdomain"
            label={subdomainLabelOptions}
            labelPosition="right"
            value={formFields.subdomainInput}
            errorMessage={formFieldsErrors.subdomainInput}
            onChange={this.handleSubdomainChange}
            onBlur={this.handleSubdomainBlur}
            fieldRefCallback={this.takeSubdomainRef}
            validatedFieldComponent={ParsedInput}
            parse={slugify}
          />
        </Form.Field>
        <Form.Field>
          <ValidatedField
            type="checkbox"
            value={formFields.termsCheckbox}
            errorMessage={formFieldsErrors.termsCheckbox}
            onChange={propFunc(this.handleCheckboxChange, 'termsCheckbox')}
            validatedFieldComponent={Checkbox}
            label={
              // eslint-disable-next-line jsx-a11y/label-has-for
              <label>
                {"I have read and accepted Groove's "}
                <a
                  href="https://www.groovehq.com/our/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>{' '}
                and{' '}
                <a
                  href="https://www.groovehq.com/our/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </label>
            }
          />
        </Form.Field>
        <Form.Button
          primary
          size="big"
          fluid
          disabled={!canSave}
          onClick={submitForm}
        >
          {!saving ? 'Create account' : 'Creating account...'}
        </Form.Button>
      </Form>
    )
  }
}

export default SignupForm
